export default __webpack_public_path__ + "static/bronze-b6ca38389886026e45c4b33f783ac809.png";